import React, {Component, ReactElement, ReactNode} from 'react'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {Nullable} from '../../../app/TypeHelpers'
import NatCondominiumGroupRepo from './repository/NatCondominiumGroupRepo'
import {CondominiumGroupData, NatGetCondominiumGroup} from './repository/NatGetCondominiumGroup'
import {
    NatPostCondominiumGroupParams,
    NatPostCondominiumGroupResponse,
    RegisterCondominiumGroup,
} from './repository/NatPostCondominiumGroup'
import {Messages} from '../../../Messages'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../components/shared/hoc/withAdminPageTemplate'
import {AdminPrimaryButton} from '../../../styledComponents/adminPage/Buttons'
import {BackLink, DeleteLink} from '../../../styledComponents/adminPage/Links'
import {HKConstants} from '../../../HKConstants'
import AuthorityChecker from '../../../components/AuthorityChecker'
import {StyledTableCaption, TableRowName} from '../../../styledComponents/adminPage/Table'
import {LeftRowFlexContainer} from '../../../styledComponents/FlexComponents'
import {StyledLabel} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {judgeAuthorityCheck} from '../../common/util/Natutil'
import PPTextField from '../../../components/shared/forms/PPTextField'
import {HeadingAreaMessageParams} from '../../../components/shared/pageBaseComponents/HeadingAreaMessageComponent'
import {MESSAGE_TYPE} from '../../../CodeMaster'
import {Location} from 'react-router-dom'

import {Table, TableBody, TableCell, TableRow} from '@mui/material'

const PREFIX_WORK_CONDOMINIUM_GROUP_ID = 'work_'
const INITIAL_MESSAGE_TYPE_PUT = 'put'
const INITIAL_MESSAGE_TYPE_CANCEL = 'cancel'


interface Props {
    condominiumGroupRepo: NatCondominiumGroupRepo
    eventEmitter: EventEmitterExAdmin
    location: Location,
}

interface States {
    isLoadCompleted: boolean
    condominiumGroup: CondominiumGroupData
    postCondominiumGroupParams: NatPostCondominiumGroupParams
    headerMessage: string
    condominiumGroupDispStatus: boolean[]
    level2CondominiumGroupDispStatus: boolean
    level3CondominiumGroupDispStatus: boolean[]
    level4CondominiumGroupDispStatus: boolean[][]
    condominiumGroupLength: number
    prefixWorkCondominiumGroupId: number
    changeCondominiumGroupList: string[]
    condominiumGroupMasterIdName: CondominiumGroupMasterIdName[]
}

interface CondominiumGroupMasterIdName {
    condominiumGroupId: string
    condominiumGroupName: string
}

class NatAdminCondominiumGroupEditPage extends Component<Props & AdminPagePropsSet, States> {

    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        let headerMessage: string = ''
        if (this.props.location.state && this.props.location.state.message) {
            headerMessage = this.props.location.state.message
        }

        this.state = {
            isLoadCompleted: false,
            condominiumGroup: {
                level1CondominiumGroupId: '',
                level1CondominiumGroupName: '',
                level1CondominiumGroupVersion: 0,
                level2CondominiumGroupInfo: [],
            },
            postCondominiumGroupParams: {
                registerCondominiumGroup: [],
                updateCondominiumGroup: [],
                deleteCondominiumGroup: [],
            },
            headerMessage: headerMessage,
            condominiumGroupDispStatus: [],
            level2CondominiumGroupDispStatus: true,
            level3CondominiumGroupDispStatus: [],
            level4CondominiumGroupDispStatus: [],
            condominiumGroupLength: 0,
            prefixWorkCondominiumGroupId: 0,
            changeCondominiumGroupList: [],
            condominiumGroupMasterIdName: [],
        }

        this.cancelLinkClick = this.cancelLinkClick.bind(this)
        this.editButton = this.editButton.bind(this)
        this.editButtonCancelClick = this.editButtonCancelClick.bind(this)
        this.editButtonOkClick = this.editButtonOkClick.bind(this)
        this.cancelLinkCancelClick = this.cancelLinkCancelClick.bind(this)
        this.cancelLinkOkClick = this.cancelLinkOkClick.bind(this)
        this.allCloseButton = this.allCloseButton.bind(this)
        this.allOpenButton = this.allOpenButton.bind(this)
        this.rendarViewAuth = this.rendarViewAuth.bind(this)
        this.rendarEditAuth = this.rendarEditAuth.bind(this)
        this.deleteLevel2 = this.deleteLevel2.bind(this)
        this.deleteLevel2Ok = this.deleteLevel2Ok.bind(this)
        this.deleteLevel3 = this.deleteLevel3.bind(this)
        this.deleteLevel3Ok = this.deleteLevel3Ok.bind(this)
        this.deleteLevel4 = this.deleteLevel4.bind(this)
        this.deleteLevel4Ok = this.deleteLevel4Ok.bind(this)
        this.onChangeCondominiumGroupName = this.onChangeCondominiumGroupName.bind(this)
        this.judgeChangeCondominiumGroupName = this.judgeChangeCondominiumGroupName.bind(this)
        this.deleteCancel = this.deleteCancel.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            const condominiumGroupResponse: Nullable<NatGetCondominiumGroup> = await this.props.asyncCallFunction(
                this.props.condominiumGroupRepo.getCondominiumGroup.bind(this.props.condominiumGroupRepo),
                (httpErrorOrNetworkError) => {
                    httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
            )
            if (condominiumGroupResponse && condominiumGroupResponse.details) {
                const condominiumGroupMasterIdName: CondominiumGroupMasterIdName[] = []
                condominiumGroupMasterIdName.push({
                    condominiumGroupId: String(condominiumGroupResponse.details.level1CondominiumGroupId),
                    condominiumGroupName: condominiumGroupResponse.details.level1CondominiumGroupName,
                })
                let condominiumGroupLength: number = 2
                const level2CondominiumGroupDispStatus: boolean = true
                const level3CondominiumGroupDispStatus: boolean[] = []
                const level4CondominiumGroupDispStatus: boolean[][] = []
                if (condominiumGroupResponse.details.level2CondominiumGroupInfo) {
                    condominiumGroupResponse.details.level2CondominiumGroupInfo.map(
                        (level2CondominiumGroup, index1) => {
                            condominiumGroupMasterIdName.push({
                                condominiumGroupId: String(level2CondominiumGroup.level2CondominiumGroupId),
                                condominiumGroupName: level2CondominiumGroup.level2CondominiumGroupName,
                            })
                            level3CondominiumGroupDispStatus[index1] = true
                            level4CondominiumGroupDispStatus[index1] = []
                            condominiumGroupLength = condominiumGroupLength + 1
                            if (level2CondominiumGroup.level3CondominiumGroupInfo &&
                                level2CondominiumGroup.level3CondominiumGroupInfo.length > 0) {
                                level2CondominiumGroup.level3CondominiumGroupInfo.map(
                                    (level3CondominiumGroup, index2) => {
                                        condominiumGroupMasterIdName.push({
                                            condominiumGroupId: String(level3CondominiumGroup.level3CondominiumGroupId),
                                            condominiumGroupName: level3CondominiumGroup.level3CondominiumGroupName,
                                        })
                                        level4CondominiumGroupDispStatus[index1][index2] = true
                                        condominiumGroupLength = condominiumGroupLength + 1
                                        if (level3CondominiumGroup.level4CondominiumGroupInfo) {
                                            level3CondominiumGroup.level4CondominiumGroupInfo.map(
                                                (level4CondominiumGroup, index3) => {
                                                    condominiumGroupMasterIdName.push({
                                                        condominiumGroupId:
                                                            String(level4CondominiumGroup.level4CondominiumGroupId),
                                                        condominiumGroupName:
                                                        level4CondominiumGroup.level4CondominiumGroupName,
                                                    })
                                                    condominiumGroupLength = condominiumGroupLength + 1
                                                })
                                        }
                                    })
                            } else {
                                level4CondominiumGroupDispStatus[index1] = []
                            }
                        })
                }
                this.setState({
                    condominiumGroup: condominiumGroupResponse.details,
                    level2CondominiumGroupDispStatus: level2CondominiumGroupDispStatus,
                    level3CondominiumGroupDispStatus: level3CondominiumGroupDispStatus,
                    level4CondominiumGroupDispStatus: level4CondominiumGroupDispStatus,
                    condominiumGroupLength: condominiumGroupLength,
                    condominiumGroupMasterIdName: condominiumGroupMasterIdName,
                })


            }
            this.showInitialMessage()
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
    }

    getCondominiumGroupMasterName(condominiumGroupId: string): string {
        if (condominiumGroupId.startsWith(PREFIX_WORK_CONDOMINIUM_GROUP_ID)) {
            return ''
        }
        const condominiumGroupMasterTarget: CondominiumGroupMasterIdName[] =
            this.state.condominiumGroupMasterIdName.filter((condominiumGroupMaster) => {
                return (condominiumGroupMaster.condominiumGroupId === condominiumGroupId)
            })
        return condominiumGroupMasterTarget[0].condominiumGroupName
    }

    showInitialMessage(): void {
        if (!this.props.location || !this.props.location.state) {
            return
        }
        if (this.props.location.state.initialMessageType === INITIAL_MESSAGE_TYPE_CANCEL) {
            const initialMessage: HeadingAreaMessageParams = {
                title: null,
                messageLevel: MESSAGE_TYPE.INFORMATION,
                detail: Messages.IOPCC0013.toString(''),
            }
            this.props.navigate(this.props.location.pathname, {replace: true})
            this.props.eventEmitter.showHeadingAreaMessage(initialMessage)

        } else if (this.props.location.state.initialMessageType === INITIAL_MESSAGE_TYPE_PUT) {
            const initialMessage: HeadingAreaMessageParams = {
                title: null,
                messageLevel: MESSAGE_TYPE.INFORMATION,
                detail: Messages.IOPCC0008.toString('物件グループの設定'),
            }
            this.props.navigate(this.props.location.pathname, {replace: true})
            this.props.eventEmitter.showHeadingAreaMessage(initialMessage)

        } else {
            return
        }
    }

    allOpenButton(): void {
        this.setState({level2CondominiumGroupDispStatus: true})
        const level3CondominiumGroupDispStatus = this.state.level3CondominiumGroupDispStatus
        level3CondominiumGroupDispStatus.forEach(
            (level3CondominiumGroup, index1) => {
                level3CondominiumGroupDispStatus[index1] = true
            })
        const level4CondominiumGroupDispStatus = this.state.level4CondominiumGroupDispStatus
        level4CondominiumGroupDispStatus.forEach(
            (level3CondominiumGroup, index1) => {
                level3CondominiumGroup.forEach(
                    (level4CondominiumGroup, index2) => {
                        level4CondominiumGroupDispStatus[index1][index2] = true
                    })
            })

        this.setState({level3CondominiumGroupDispStatus: level3CondominiumGroupDispStatus})
    }

    allCloseButton(): void {
        this.setState({level2CondominiumGroupDispStatus: false})
        const level3CondominiumGroupDispStatus = this.state.level3CondominiumGroupDispStatus
        level3CondominiumGroupDispStatus.forEach(
            (level3CondominiumGroup, index1) => {
                level3CondominiumGroupDispStatus[index1] = false
            })
        const level4CondominiumGroupDispStatus = this.state.level4CondominiumGroupDispStatus
        level4CondominiumGroupDispStatus.forEach(
            (level3CondominiumGroup, index1) => {
                level3CondominiumGroup.forEach(
                    (level4CondominiumGroup, index2) => {
                        level4CondominiumGroupDispStatus[index1][index2] = false
                    })
            })

        this.setState({level3CondominiumGroupDispStatus: level3CondominiumGroupDispStatus})
    }

    cancelLinkCancelClick(): void {
        this.props.eventEmitter.closeDialog()
    }

    cancelLinkOkClick(): void {
        this.props.eventEmitter.closeDialog()
        this.props.navigate(
            `/admin/condominiumGroupEdit`,
            {
                state: {
                    initialMessageType: INITIAL_MESSAGE_TYPE_CANCEL,
                },
            },
        )
        window.location.reload()
    }

    editButtonCancelClick(): void {
        this.props.eventEmitter.closeDialog()
    }

    async editButtonOkClick(): Promise<void> {
        this.props.eventEmitter.closeDialog()
        await this.props.eventEmitter.showLoading()
        try {
            const postCondominiumGroupResponse: Nullable<NatPostCondominiumGroupResponse> =
                await this.props.asyncCallFunction(
                    this.props.condominiumGroupRepo.postCondominiumGroup.bind(
                        this.props.condominiumGroupRepo, this.state.postCondominiumGroupParams,
                    ),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.EOPCA0001.toString('物件グループ')},
                )
            if (postCondominiumGroupResponse && postCondominiumGroupResponse.requestError === null) {
                this.props.navigate(
                    `/admin/condominiumGroupEdit`,
                    {
                        state: {
                            initialMessageType: INITIAL_MESSAGE_TYPE_PUT,
                        },
                    },
                )
                window.location.reload()
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async editButton(): Promise<void> {
        await this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: Messages.IOPCC0012.errorLevel,
                message: Messages.IOPCC0012.toString('物件グループ'),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.editButtonCancelClick,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.editButtonOkClick,
                    },
                ],
            },
        )
    }

    cancelLinkClick(): void {
        this.props.eventEmitter.showDialog({
                title: '警告',
                errorLevel: Messages.WOPCC0001.errorLevel,
                message: Messages.WOPCC0001.toString(''),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.cancelLinkCancelClick,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.cancelLinkOkClick,
                    },
                ],
            },
        )
    }

    clickLevel1Open(): void {
        this.setState({level2CondominiumGroupDispStatus: true})
    }

    clickLevel1Close(): void {
        this.setState({level2CondominiumGroupDispStatus: false})
    }

    JudgLevel1DispIcon(): ReactElement {
        if (this.state.level2CondominiumGroupDispStatus) {
            return (
                <KeyboardArrowDownIcon
                    fontSize={'large'}
                    onClick={() => this.clickLevel1Close()}
                />
            )
        } else {
            return (
                <KeyboardArrowRightIcon
                    fontSize={'large'}
                    onClick={() => this.clickLevel1Open()}
                />
            )
        }
    }

    clickLevel2Open(index: number): void {
        const level3CondominiumGroupDispStatus = this.state.level3CondominiumGroupDispStatus
        level3CondominiumGroupDispStatus[index] = true
        this.setState({level3CondominiumGroupDispStatus: level3CondominiumGroupDispStatus})
    }

    clickLevel2Close(index: number): void {
        const level3CondominiumGroupDispStatus = this.state.level3CondominiumGroupDispStatus
        level3CondominiumGroupDispStatus[index] = false
        this.setState({level3CondominiumGroupDispStatus: level3CondominiumGroupDispStatus})
    }

    JudgLevel2DispIcon(index: number): ReactElement {
        if (this.state.level3CondominiumGroupDispStatus[index]) {
            return (
                <KeyboardArrowDownIcon
                    fontSize={'large'}
                    onClick={() => this.clickLevel2Close(index)}
                />
            )
        } else {
            return (
                <KeyboardArrowRightIcon
                    fontSize={'large'}
                    onClick={() => this.clickLevel2Open(index)}
                />
            )
        }
    }


    clickLevel3Open(index1: number, index2: number): void {
        const level4CondominiumGroupDispStatus = this.state.level4CondominiumGroupDispStatus
        level4CondominiumGroupDispStatus[index1][index2] = true
        this.setState({level4CondominiumGroupDispStatus: level4CondominiumGroupDispStatus})
    }

    clickLevel3Close(index1: number, index2: number): void {
        const level4CondominiumGroupDispStatus = this.state.level4CondominiumGroupDispStatus
        level4CondominiumGroupDispStatus[index1][index2] = false
        this.setState({level4CondominiumGroupDispStatus: level4CondominiumGroupDispStatus})
    }

    JudgLevel3DispIcon(index1: number, index2: number): ReactElement {

        if (this.state.level4CondominiumGroupDispStatus[index1][index2]) {
            return (
                <KeyboardArrowDownIcon
                    fontSize={'large'}
                    onClick={() => this.clickLevel3Close(index1, index2)}
                />
            )
        } else {
            return (
                <KeyboardArrowRightIcon
                    fontSize={'large'}
                    onClick={() => this.clickLevel3Open(index1, index2)}
                />
            )
        }
    }

    renderLevel2DeleteLink(level2Index: number): ReactElement {

        let deleteLinkDispFlag: boolean = true
        let targetCondominiumGroupId: string = ''
        if (this.state.condominiumGroup.level2CondominiumGroupInfo) {
            this.state.condominiumGroup.level2CondominiumGroupInfo.some((level2CondominiumGroupInfo, index) => {
                if (index === level2Index) {
                    targetCondominiumGroupId = String(level2CondominiumGroupInfo.level2CondominiumGroupId)
                    if (level2CondominiumGroupInfo.level3CondominiumGroupInfo &&
                        level2CondominiumGroupInfo.level3CondominiumGroupInfo.length > 0) {
                        deleteLinkDispFlag = false
                    }
                    return true
                }
            })
        }

        const targetCondominiumGroupMasterName: string = this.getCondominiumGroupMasterName(targetCondominiumGroupId)

        if (deleteLinkDispFlag) {
            return (
                <DeleteLink
                    onClick={() => this.deleteLevel2(
                        targetCondominiumGroupId, targetCondominiumGroupMasterName, level2Index)}>
                    削除する
                </DeleteLink>
            )
        } else {
            return (<></>)
        }
    }

    renderLevel3DeleteLink(level2Index: number, level3Index: number): ReactElement {

        let deleteLinkDispFlag: boolean = true
        let targetCondominiumGroupId: string = ''
        if (this.state.condominiumGroup.level2CondominiumGroupInfo) {
            this.state.condominiumGroup.level2CondominiumGroupInfo.some((level2CondominiumGroupInfo, index) => {
                if (index === level2Index) {
                    if (level2CondominiumGroupInfo.level3CondominiumGroupInfo) {
                        level2CondominiumGroupInfo.level3CondominiumGroupInfo.some(
                            (level3CondominiumGroupInfo, index2) => {
                                if (index2 === level3Index) {
                                    targetCondominiumGroupId =
                                        String(level3CondominiumGroupInfo.level3CondominiumGroupId)
                                    if (level3CondominiumGroupInfo.level4CondominiumGroupInfo &&
                                        level3CondominiumGroupInfo.level4CondominiumGroupInfo.length > 0) {
                                        deleteLinkDispFlag = false
                                    }
                                    return true
                                }
                            })
                    }
                    return true
                }
            })
        }

        const targetCondominiumGroupMasterName: string = this.getCondominiumGroupMasterName(targetCondominiumGroupId)

        if (deleteLinkDispFlag) {
            return (
                <DeleteLink
                    onClick={() => this.deleteLevel3(
                        targetCondominiumGroupId, targetCondominiumGroupMasterName, level2Index, level3Index)}>
                    削除する
                </DeleteLink>
            )
        } else {
            return (<></>)
        }
    }

    deleteCancel(): void {
        this.props.eventEmitter.closeDialog()
    }


    deleteLevel2(targetCondominiumGroupId: string, targetCondominiumGroupMasterName: string, level2: number): void {
        if (targetCondominiumGroupId.startsWith(PREFIX_WORK_CONDOMINIUM_GROUP_ID)) {
            // 新規で追加した物件グループの場合
            this.deleteLevel2Ok(level2)
            this.deleteWorkCondominiumGroup(targetCondominiumGroupId)
        } else {
            this.props.eventEmitter.showDialog({
                    title: '確認',
                    errorLevel: Messages.IOPCC0011.errorLevel,
                    message: Messages.IOPCC0011.toString(targetCondominiumGroupMasterName),
                    buttonProps: [
                        {
                            isDefault: false,
                            buttonLabel: 'キャンセル',
                            buttonHandler: this.deleteCancel,
                        },
                        {
                            isDefault: false,
                            buttonLabel: 'OK',
                            buttonHandler: () => this.deleteLevel2Ok(level2),
                        },
                    ],
                },
            )
        }

    }


    deleteLevel2Ok(level2: number): void {
        const postCondominiumGroupResponseParams = this.state.postCondominiumGroupParams
        const condominiumGroup = this.state.condominiumGroup
        if (condominiumGroup.level2CondominiumGroupInfo) {
            if (!String(condominiumGroup.level2CondominiumGroupInfo[level2].level2CondominiumGroupId).startsWith(
                PREFIX_WORK_CONDOMINIUM_GROUP_ID,
            )) {
                postCondominiumGroupResponseParams.deleteCondominiumGroup.push({
                    condominiumGroupId:
                        String(condominiumGroup.level2CondominiumGroupInfo[level2].level2CondominiumGroupId),
                })
            }
            condominiumGroup.level2CondominiumGroupInfo.splice(level2, 1)

        }

        const level3CondominiumGroupDispStatus = this.state.level3CondominiumGroupDispStatus
        level3CondominiumGroupDispStatus.splice(level2, 1)
        this.setState({
            condominiumGroup: condominiumGroup,
            postCondominiumGroupParams: postCondominiumGroupResponseParams,
        })
        this.props.eventEmitter.closeDialog()
    }

    deleteLevel3(targetCondominiumGroupId: string,
                 targetCondominiumGroupMasterName: string,
                 level2: number, level3: number): void {
        if (targetCondominiumGroupId.startsWith(PREFIX_WORK_CONDOMINIUM_GROUP_ID)) {
            // 新規で追加した物件グループの場合
            this.deleteLevel3Ok(level2, level3)
            this.deleteWorkCondominiumGroup(targetCondominiumGroupId)
        } else {
            this.props.eventEmitter.showDialog({
                    title: '確認',
                    errorLevel: Messages.IOPCC0011.errorLevel,
                    message: Messages.IOPCC0011.toString(targetCondominiumGroupMasterName),
                    buttonProps: [
                        {
                            isDefault: false,
                            buttonLabel: 'キャンセル',
                            buttonHandler: this.deleteCancel,
                        },
                        {
                            isDefault: false,
                            buttonLabel: 'OK',
                            buttonHandler: () => this.deleteLevel3Ok(level2, level3),
                        },
                    ],
                },
            )
        }

    }


    deleteLevel3Ok(level2: number, level3: number): void {
        const postCondominiumGroupResponseParams = this.state.postCondominiumGroupParams
        const condominiumGroup = this.state.condominiumGroup
        if (condominiumGroup.level2CondominiumGroupInfo) {
            condominiumGroup.level2CondominiumGroupInfo.map((level2CondominiumGroupInfo, level2Index) => {
                if (level2 === level2Index && level2CondominiumGroupInfo.level3CondominiumGroupInfo) {
                    if (!String(level2CondominiumGroupInfo.level3CondominiumGroupInfo[level3].level3CondominiumGroupId)
                        .startsWith(PREFIX_WORK_CONDOMINIUM_GROUP_ID)) {
                        postCondominiumGroupResponseParams.deleteCondominiumGroup.push({
                            condominiumGroupId:
                                String(
                                    // tslint:disable-next-line:max-line-length
                                    level2CondominiumGroupInfo.level3CondominiumGroupInfo[level3].level3CondominiumGroupId,
                                ),
                        })
                    }
                    level2CondominiumGroupInfo.level3CondominiumGroupInfo.splice(level3, 1)
                }
            })
        }

        const level4CondominiumGroupDispStatus = this.state.level4CondominiumGroupDispStatus
        level4CondominiumGroupDispStatus[level2].splice(level3, 1)
        this.setState({
            condominiumGroup: condominiumGroup,
            postCondominiumGroupParams: postCondominiumGroupResponseParams,
        })
        this.props.eventEmitter.closeDialog()
    }


    deleteLevel4(targetCondominiumGroupId: string,
                 level2: number, level3: number, level4: number): void {
        if (targetCondominiumGroupId.startsWith(PREFIX_WORK_CONDOMINIUM_GROUP_ID)) {
            // 新規で追加した物件グループの場合
            this.deleteLevel4Ok(level2, level3, level4)
            this.deleteWorkCondominiumGroup(targetCondominiumGroupId)
        } else {
            const targetCondominiumGroupMasterName = this.getCondominiumGroupMasterName(targetCondominiumGroupId)
            this.props.eventEmitter.showDialog({
                    title: '確認',
                    errorLevel: Messages.IOPCC0011.errorLevel,
                    message: Messages.IOPCC0011.toString(targetCondominiumGroupMasterName),
                    buttonProps: [
                        {
                            isDefault: false,
                            buttonLabel: 'キャンセル',
                            buttonHandler: this.deleteCancel,
                        },
                        {
                            isDefault: false,
                            buttonLabel: 'OK',
                            buttonHandler: () => this.deleteLevel4Ok(level2, level3, level4),
                        },
                    ],
                },
            )
        }
    }


    deleteLevel4Ok(level2: number, level3: number, level4: number): void {

        const postCondominiumGroupResponseParams = this.state.postCondominiumGroupParams
        const condominiumGroup = this.state.condominiumGroup
        if (condominiumGroup.level2CondominiumGroupInfo) {
            condominiumGroup.level2CondominiumGroupInfo.map((level2CondominiumGroupInfo, level2Index) => {
                if (level2 === level2Index && level2CondominiumGroupInfo.level3CondominiumGroupInfo) {
                    level2CondominiumGroupInfo.level3CondominiumGroupInfo.map(
                        (level3CondominiumGroupInfo, level3Index) => {
                            if (level3 === level3Index && level3CondominiumGroupInfo.level4CondominiumGroupInfo) {
                                // tslint:disable-next-line:max-line-length
                                if (!String(level3CondominiumGroupInfo.level4CondominiumGroupInfo[level4].level4CondominiumGroupId).startsWith(PREFIX_WORK_CONDOMINIUM_GROUP_ID)) {
                                    postCondominiumGroupResponseParams.deleteCondominiumGroup.push({
                                        condominiumGroupId:
                                            String(
                                                // tslint:disable-next-line:max-line-length
                                                level3CondominiumGroupInfo.level4CondominiumGroupInfo[level4].level4CondominiumGroupId,
                                            ),
                                    })
                                }
                                level3CondominiumGroupInfo.level4CondominiumGroupInfo.splice(level4, 1)
                            }
                        })
                }
            })
        }

        this.setState({
            condominiumGroup: condominiumGroup,
            postCondominiumGroupParams: postCondominiumGroupResponseParams,
        })
        this.props.eventEmitter.closeDialog()

    }

    deleteWorkCondominiumGroup(condominiumGroupWorkId: string): void {
        const postCondominiumGroupParams = this.state.postCondominiumGroupParams
        const registerCondominiumGroup: RegisterCondominiumGroup[] =
            this.state.postCondominiumGroupParams.registerCondominiumGroup.filter((condominiumGroup) => {
                return (condominiumGroup.condominiumGroupIdWork !== condominiumGroupWorkId)
            })
        postCondominiumGroupParams.registerCondominiumGroup = registerCondominiumGroup
        this.setState({postCondominiumGroupParams: postCondominiumGroupParams})
    }

    onChangeCondominiumGroupName(
        condominiumGroupId: string,
        version: number,
        levelIndex: string,
        event: React.ChangeEvent<HTMLInputElement>): void {

        const condominiumGroup = this.state.condominiumGroup
        const postCondominiumGroupResponseParams = this.state.postCondominiumGroupParams
        const changeCondominiumGroupList = this.state.changeCondominiumGroupList
        const levelIndexList = levelIndex.split(',')


        if (condominiumGroupId.startsWith(PREFIX_WORK_CONDOMINIUM_GROUP_ID)) {
            // 新規で追加した物件グループの場合
            postCondominiumGroupResponseParams.registerCondominiumGroup.some((registerCondominiumGroup) => {
                if (condominiumGroupId === registerCondominiumGroup.condominiumGroupIdWork) {
                    registerCondominiumGroup.condominiumGroupName = event.target.value
                    changeCondominiumGroupList.push(condominiumGroupId)
                    return true
                }
            })
        } else {
            // 既存の物件グループの場合

            // 変更する前
            const condominiumGroupNameMaster: string = this.getCondominiumGroupMasterName(condominiumGroupId)
            // 変更した値
            const condominiumGroupName: string = event.target.value

            if (condominiumGroupName !== condominiumGroupNameMaster) {
                let exitUpdateCondominiumGroupFlag: boolean = false
                postCondominiumGroupResponseParams.updateCondominiumGroup.some((updateCondominiumGroup) => {
                    if (condominiumGroupId === updateCondominiumGroup.condominiumGroupId) {
                        updateCondominiumGroup.condominiumGroupName = event.target.value
                        exitUpdateCondominiumGroupFlag = true
                        return true
                    }
                })
                if (!exitUpdateCondominiumGroupFlag) {
                    changeCondominiumGroupList.push(condominiumGroupId)
                    postCondominiumGroupResponseParams.updateCondominiumGroup.push(
                        {
                            condominiumGroupId: condominiumGroupId,
                            version: version,
                            condominiumGroupName: event.target.value,
                        },
                    )
                }
            } else {
                changeCondominiumGroupList.some((changeCondominiumGroupId, index) => {
                    if (changeCondominiumGroupId === condominiumGroupId) {
                        changeCondominiumGroupList.splice(index, 1)
                        return true
                    }
                })

                postCondominiumGroupResponseParams.updateCondominiumGroup.some((updateCondominiumGroup, index) => {
                    if (condominiumGroupId === updateCondominiumGroup.condominiumGroupId) {
                        postCondominiumGroupResponseParams.updateCondominiumGroup.splice(index, 1)
                        return true
                    }
                })
            }
        }

        const level2Index = levelIndexList[0] ? Number(levelIndexList[0]) : null
        const level3Index = levelIndexList[1] ? Number(levelIndexList[1]) : null
        const level4Index = levelIndexList[2] ? Number(levelIndexList[2]) : null

        // 階層レベル4の物件グループ名の変更
        if (level2Index !== null && level3Index !== null && level4Index !== null) {
            if (condominiumGroup.level2CondominiumGroupInfo &&
                condominiumGroup.level2CondominiumGroupInfo[level2Index] &&
                condominiumGroup.level2CondominiumGroupInfo[level2Index].level3CondominiumGroupInfo
            ) {
                const level3CondominiumGroupInfo =
                    condominiumGroup.level2CondominiumGroupInfo[level2Index].level3CondominiumGroupInfo
                if (level3CondominiumGroupInfo &&
                    level3CondominiumGroupInfo[level3Index] &&
                    level3CondominiumGroupInfo[level3Index].level4CondominiumGroupInfo
                ) {
                    const level4CondominiumGroupInfo =
                        level3CondominiumGroupInfo[level3Index].level4CondominiumGroupInfo
                    if (level4CondominiumGroupInfo && level4CondominiumGroupInfo[level4Index]) {
                        level4CondominiumGroupInfo[level4Index].level4CondominiumGroupName = event.target.value
                    }
                }
            }
        }

        // 階層レベル3の物件グループ名の変更
        if (level2Index !== null && level3Index !== null && level4Index === null) {
            if (condominiumGroup.level2CondominiumGroupInfo &&
                condominiumGroup.level2CondominiumGroupInfo[level2Index] &&
                condominiumGroup.level2CondominiumGroupInfo[level2Index].level3CondominiumGroupInfo
            ) {
                const level3CondominiumGroupInfo =
                    condominiumGroup.level2CondominiumGroupInfo[level2Index].level3CondominiumGroupInfo
                if (level3CondominiumGroupInfo &&
                    level3CondominiumGroupInfo[level3Index]
                ) {
                    level3CondominiumGroupInfo[level3Index].level3CondominiumGroupName = event.target.value
                }
            }

        }

        // 階層レベル2の物件グループ名の変更
        if (level2Index !== null && level3Index === null && level4Index === null) {
            if (condominiumGroup.level2CondominiumGroupInfo &&
                condominiumGroup.level2CondominiumGroupInfo[level2Index]) {
                condominiumGroup.level2CondominiumGroupInfo[level2Index].level2CondominiumGroupName = event.target.value
            }

        }

        this.setState({
            condominiumGroup: condominiumGroup,
            postCondominiumGroupParams: postCondominiumGroupResponseParams,
            changeCondominiumGroupList: changeCondominiumGroupList,
        })
    }


    render(): ReactElement {
        if (!this.state.isLoadCompleted) {
            return (<></>)
        }
        return (
            <>
                <PageMainArea>
                    {this.renderPageMainArea()}
                </PageMainArea>
                <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.EDIT_CONDOMINIUM_GROUP}>
                    <PageFooterArea>
                        {this.renderPageFooterArea()}
                    </PageFooterArea>
                </AuthorityChecker>
            </>
        )
    }

    renderPageFooterArea(): ReactNode {
        return (
            <>
                <PageFotterAreaRight>
                    <AdminPrimaryButton
                        onClick={this.editButton}
                    >
                        登録
                    </AdminPrimaryButton>
                </PageFotterAreaRight>
                <PageFotterAreaLeft>
                    <BackLink
                        onClick={this.cancelLinkClick}
                    >
                        キャンセル
                    </BackLink>
                </PageFotterAreaLeft>
            </>
        )
    }

    rendarViewAuth(): ReactNode {
        return (<>
            <TableRow key={this.state.condominiumGroup.level1CondominiumGroupId}>
                <TableCell>
                    <LeftRowFlexContainer>
                        {this.JudgLevel1DispIcon()}
                        {this.state.condominiumGroup.level1CondominiumGroupName}
                    </LeftRowFlexContainer>
                </TableCell>
            </TableRow>
            {this.state.level2CondominiumGroupDispStatus &&
                this.state.condominiumGroup.level2CondominiumGroupInfo &&
                this.state.condominiumGroup.level2CondominiumGroupInfo.map((level2CondominiumGroup, level2) => (<>
                    <TableRow key={level2CondominiumGroup.level2CondominiumGroupId}>
                        <TableCell>
                            <LeftRowFlexContainer>
                                {'　'}
                                {this.JudgLevel2DispIcon(level2)}
                                {level2CondominiumGroup.level2CondominiumGroupName}
                            </LeftRowFlexContainer>
                        </TableCell>
                    </TableRow>

                    {this.state.level3CondominiumGroupDispStatus[level2] &&
                        level2CondominiumGroup.level3CondominiumGroupInfo &&
                        level2CondominiumGroup.level3CondominiumGroupInfo.length > 0 &&
                        level2CondominiumGroup.level3CondominiumGroupInfo.map((level3CondominiumGroup, level3) => (<>
                            <TableRow key={level3CondominiumGroup.level3CondominiumGroupId}>
                                <TableCell>
                                    <LeftRowFlexContainer>
                                        {'　　　　'}
                                        {this.JudgLevel3DispIcon(level2, level3)}
                                        {level3CondominiumGroup.level3CondominiumGroupName}
                                    </LeftRowFlexContainer>
                                </TableCell>
                            </TableRow>
                            {this.state.level4CondominiumGroupDispStatus[level2][level3] &&
                                level3CondominiumGroup.level4CondominiumGroupInfo &&
                                level3CondominiumGroup.level4CondominiumGroupInfo.map(
                                    (level4CondominiumGroup, index4) => (
                                        <TableRow key={level4CondominiumGroup.level4CondominiumGroupId}>
                                            <TableCell>
                                                <LeftRowFlexContainer>
                                                    {'　　　　　　　　'}
                                                    {level4CondominiumGroup.level4CondominiumGroupName}
                                                </LeftRowFlexContainer>
                                            </TableCell>
                                        </TableRow>
                                    ))
                            }
                        </>))
                    }
                </>))
            }
        </>)
    }

    addLevel2CondominiumGroup(level1CondominiumGroupId: string): void {
        const postCondominiumGroupResponseParams: NatPostCondominiumGroupParams =
            this.state.postCondominiumGroupParams

        const changeCondominiumGroupList = this.state.changeCondominiumGroupList
        changeCondominiumGroupList.push(PREFIX_WORK_CONDOMINIUM_GROUP_ID +
            String(this.state.prefixWorkCondominiumGroupId + 1))

        postCondominiumGroupResponseParams.registerCondominiumGroup.push({
            condominiumGroupIdWork: PREFIX_WORK_CONDOMINIUM_GROUP_ID +
                String(this.state.prefixWorkCondominiumGroupId + 1),
            condominiumGroupName: '',
            parentCondominiumGroupId: level1CondominiumGroupId,
            layerLevel: '2',
        })

        const condominiumGroup = this.state.condominiumGroup
        if (condominiumGroup.level2CondominiumGroupInfo) {
            condominiumGroup.level2CondominiumGroupInfo.push(
                {
                    level2CondominiumGroupName: '',
                    level2CondominiumGroupId: PREFIX_WORK_CONDOMINIUM_GROUP_ID +
                        String(this.state.prefixWorkCondominiumGroupId + 1),
                    level2CondominiumGroupVersion: 0,
                    level3CondominiumGroupInfo: [],
                },
            )
        }

        const condominiumGroupLength: number = this.state.condominiumGroupLength + 1
        const prefixWorkCondominiumGroupId: number = this.state.prefixWorkCondominiumGroupId + 1
        const level3CondominiumGroupDispStatus = this.state.level3CondominiumGroupDispStatus
        const level4CondominiumGroupDispStatus = this.state.level4CondominiumGroupDispStatus
        level4CondominiumGroupDispStatus.push([true])
        level3CondominiumGroupDispStatus.push(true)
        this.setState({
            level2CondominiumGroupDispStatus: true,
            postCondominiumGroupParams: postCondominiumGroupResponseParams,
            condominiumGroupLength: condominiumGroupLength,
            prefixWorkCondominiumGroupId: prefixWorkCondominiumGroupId,
        })

    }

    addLevel3CondominiumGroup(level2CondominiumGroupId: string, level2Index: number): void {

        const postCondominiumGroupResponseParams: NatPostCondominiumGroupParams =
            this.state.postCondominiumGroupParams

        const changeCondominiumGroupList = this.state.changeCondominiumGroupList
        changeCondominiumGroupList.push(PREFIX_WORK_CONDOMINIUM_GROUP_ID +
            String(this.state.prefixWorkCondominiumGroupId + 1))

        const registerCondominiumGroup: RegisterCondominiumGroup = {
            condominiumGroupIdWork: PREFIX_WORK_CONDOMINIUM_GROUP_ID +
                String(this.state.prefixWorkCondominiumGroupId + 1),
            condominiumGroupName: '',
            layerLevel: '3',
        }
        if (level2CondominiumGroupId.startsWith(PREFIX_WORK_CONDOMINIUM_GROUP_ID)) {
            registerCondominiumGroup.parentCondominiumGroupIdWork = level2CondominiumGroupId
        } else {
            registerCondominiumGroup.parentCondominiumGroupId = level2CondominiumGroupId
        }


        postCondominiumGroupResponseParams.registerCondominiumGroup.push(registerCondominiumGroup)
        this.setState({postCondominiumGroupParams: postCondominiumGroupResponseParams})

        const condominiumGroup: CondominiumGroupData = this.state.condominiumGroup

        if (condominiumGroup.level2CondominiumGroupInfo &&
            condominiumGroup.level2CondominiumGroupInfo[level2Index]
        ) {
            const tempCondominiumGroup =
                condominiumGroup.level2CondominiumGroupInfo[level2Index].level3CondominiumGroupInfo
            if (tempCondominiumGroup) {
                tempCondominiumGroup.push({
                        level3CondominiumGroupName: '',
                        level3CondominiumGroupId: PREFIX_WORK_CONDOMINIUM_GROUP_ID +
                            String(this.state.prefixWorkCondominiumGroupId + 1),
                        level3CondominiumGroupVersion: 0,
                        level4CondominiumGroupInfo: [],
                    },
                )
            }
        }

        const condominiumGroupLength: number = this.state.condominiumGroupLength + 1
        const prefixWorkCondominiumGroupId: number = this.state.prefixWorkCondominiumGroupId + 1
        const level3CondominiumGroupDispStatus = this.state.level3CondominiumGroupDispStatus
        const level4CondominiumGroupDispStatus = this.state.level4CondominiumGroupDispStatus
        level3CondominiumGroupDispStatus[level2Index] = true
        level4CondominiumGroupDispStatus[level2Index].push(true)

        this.setState({
            condominiumGroup: condominiumGroup,
            condominiumGroupLength: condominiumGroupLength,
            prefixWorkCondominiumGroupId: prefixWorkCondominiumGroupId,
            level3CondominiumGroupDispStatus: level3CondominiumGroupDispStatus,
            level4CondominiumGroupDispStatus: level4CondominiumGroupDispStatus,
        })

    }


    addLevel4CondominiumGroup(level3CondominiumGroupId: string, level2Index: number, level3Index: number): void {
        const postCondominiumGroupResponseParams: NatPostCondominiumGroupParams =
            this.state.postCondominiumGroupParams


        const changeCondominiumGroupList = this.state.changeCondominiumGroupList
        changeCondominiumGroupList.push(PREFIX_WORK_CONDOMINIUM_GROUP_ID +
            String(this.state.prefixWorkCondominiumGroupId + 1))

        const registerCondominiumGroup: RegisterCondominiumGroup = {
            condominiumGroupIdWork: PREFIX_WORK_CONDOMINIUM_GROUP_ID +
                String(this.state.prefixWorkCondominiumGroupId + 1),
            condominiumGroupName: '',
            layerLevel: '4',
        }
        if (level3CondominiumGroupId.startsWith(PREFIX_WORK_CONDOMINIUM_GROUP_ID)) {
            registerCondominiumGroup.parentCondominiumGroupIdWork = level3CondominiumGroupId
        } else {
            registerCondominiumGroup.parentCondominiumGroupId = level3CondominiumGroupId
        }


        postCondominiumGroupResponseParams.registerCondominiumGroup.push(registerCondominiumGroup)
        this.setState({postCondominiumGroupParams: postCondominiumGroupResponseParams})

        const condominiumGroup: CondominiumGroupData = this.state.condominiumGroup


        if (condominiumGroup.level2CondominiumGroupInfo &&
            condominiumGroup.level2CondominiumGroupInfo[level2Index]
        ) {
            const tempCondominiumGroup =
                condominiumGroup.level2CondominiumGroupInfo[level2Index].level3CondominiumGroupInfo
            if (tempCondominiumGroup && tempCondominiumGroup[level3Index]) {
                const tempCondominiumGroup2 = tempCondominiumGroup[level3Index].level4CondominiumGroupInfo
                if (tempCondominiumGroup2) {
                    tempCondominiumGroup2.push(
                        {
                            level4CondominiumGroupName: '',
                            level4CondominiumGroupId: PREFIX_WORK_CONDOMINIUM_GROUP_ID +
                                String(this.state.prefixWorkCondominiumGroupId + 1),
                            level4CondominiumGroupVersion: 0,
                            level4CondominiumExistFlag: '0',
                        },
                    )
                }

            }
        }

        const condominiumGroupLength: number = this.state.condominiumGroupLength + 1
        const prefixWorkCondominiumGroupId: number = this.state.prefixWorkCondominiumGroupId + 1
        const level4CondominiumGroupDispStatus = this.state.level4CondominiumGroupDispStatus
        level4CondominiumGroupDispStatus[level2Index][level3Index] = true
        this.setState({
            condominiumGroupLength: condominiumGroupLength,
            prefixWorkCondominiumGroupId: prefixWorkCondominiumGroupId,
            level4CondominiumGroupDispStatus: level4CondominiumGroupDispStatus,
        })

    }

    judgeChangeCondominiumGroupName(changeCondominiumGroupList: string[], condominiumGroupId: string): boolean {

        return changeCondominiumGroupList.indexOf(condominiumGroupId) >= 0

    }

    rendarEditAuth(): ReactNode {
        return (<>
            <TableRow>
                <TableCell>
                    <LeftRowFlexContainer>
                        {this.JudgLevel1DispIcon()}
                        {this.state.condominiumGroup.level1CondominiumGroupName}
                    </LeftRowFlexContainer>
                </TableCell>
                <TableCell>
                    <AdminPrimaryButton
                        onClick={() => this.addLevel2CondominiumGroup(
                            String(this.state.condominiumGroup.level1CondominiumGroupId),
                        )}
                    >追加
                    </AdminPrimaryButton>
                </TableCell>
                <TableCell></TableCell>
            </TableRow>
            {this.state.level2CondominiumGroupDispStatus &&
                this.state.condominiumGroup.level2CondominiumGroupInfo &&
                this.state.condominiumGroup.level2CondominiumGroupInfo.map((level2CondominiumGroup, level2) => (<>
                    <TableRow>
                        <TableCell key={level2CondominiumGroup.level2CondominiumGroupId}>
                            <LeftRowFlexContainer>
                                <pre>{'　　'}</pre>
                                {this.JudgLevel2DispIcon(level2)}
                                <CondominumGroupTextForm
                                    changeFlg={this.judgeChangeCondominiumGroupName(
                                        this.state.changeCondominiumGroupList,
                                        String(level2CondominiumGroup.level2CondominiumGroupId),
                                    )}
                                >
                                    <PPTextField
                                        InputProps={{
                                            inputProps: {
                                                maxLength: 30,
                                            },
                                        }}
                                        defaultValue={level2CondominiumGroup.level2CondominiumGroupName}
                                        onChange={this.onChangeCondominiumGroupName.bind(
                                            this,
                                            String(level2CondominiumGroup.level2CondominiumGroupId),
                                            level2CondominiumGroup.level2CondominiumGroupVersion,
                                            String(level2),
                                        )}
                                        eventKeys={
                                            [`${level2CondominiumGroup.level2CondominiumGroupId}_condominiumGroupName`]
                                        }
                                        eventEmitter={this.props.eventEmitter}
                                    />

                                </CondominumGroupTextForm>
                            </LeftRowFlexContainer>
                        </TableCell>
                        <TableCell>
                            <AdminPrimaryButton
                                onClick={() => this.addLevel3CondominiumGroup(
                                    String(level2CondominiumGroup.level2CondominiumGroupId),
                                    level2,
                                )}
                            >追加
                            </AdminPrimaryButton>
                        </TableCell>
                        <TableCell>{this.renderLevel2DeleteLink(level2)}
                        </TableCell>
                    </TableRow>

                    {this.state.level3CondominiumGroupDispStatus[level2] &&
                        level2CondominiumGroup.level3CondominiumGroupInfo &&
                        level2CondominiumGroup.level3CondominiumGroupInfo.map((level3CondominiumGroup, level3) => (<>
                            <TableRow>
                                <TableCell key={level3CondominiumGroup.level3CondominiumGroupId}>
                                    <LeftRowFlexContainer>
                                        <pre>{'　　　　'}</pre>
                                        {this.JudgLevel3DispIcon(level2, level3)}
                                        <CondominumGroupTextForm
                                            changeFlg={
                                                this.judgeChangeCondominiumGroupName(
                                                    this.state.changeCondominiumGroupList,
                                                    String(level3CondominiumGroup.level3CondominiumGroupId),
                                                )
                                            }
                                        >
                                            <PPTextField
                                                InputProps={{
                                                    inputProps: {
                                                        maxLength: 30,
                                                    },
                                                }}
                                                defaultValue={level3CondominiumGroup.level3CondominiumGroupName}
                                                onChange={this.onChangeCondominiumGroupName.bind(
                                                    this,
                                                    String(level3CondominiumGroup.level3CondominiumGroupId),
                                                    level3CondominiumGroup.level3CondominiumGroupVersion,
                                                    String(level2) + ',' + String(level3),
                                                )}
                                                eventKeys={
                                                    [`${level3CondominiumGroup.level3CondominiumGroupId}_condominiumGroupName`]
                                                }
                                                eventEmitter={this.props.eventEmitter}
                                            />
                                        </CondominumGroupTextForm>
                                    </LeftRowFlexContainer>
                                </TableCell>
                                <TableCell>
                                    <AdminPrimaryButton
                                        onClick={() => this.addLevel4CondominiumGroup(
                                            String(level3CondominiumGroup.level3CondominiumGroupId), level2, level3,
                                        )}
                                    >追加
                                    </AdminPrimaryButton>
                                </TableCell>
                                <TableCell>{this.renderLevel3DeleteLink(level2, level3)}
                                </TableCell>
                            </TableRow>
                            {this.state.level4CondominiumGroupDispStatus[level2][level3] &&
                                level3CondominiumGroup.level4CondominiumGroupInfo &&
                                level3CondominiumGroup.level4CondominiumGroupInfo.map(
                                    (level4CondominiumGroup, level4) => (
                                        <TableRow>
                                            <TableCell
                                                key={level4CondominiumGroup.level4CondominiumGroupId}
                                            >
                                                <LeftRowFlexContainer>
                                                    <pre>{'　　　　　　　　'}</pre>
                                                    <CondominumGroupTextForm
                                                        changeFlg={this.judgeChangeCondominiumGroupName(
                                                            this.state.changeCondominiumGroupList,
                                                            String(level4CondominiumGroup.level4CondominiumGroupId),
                                                        )}
                                                    >
                                                        <PPTextField
                                                            InputProps={{
                                                                inputProps: {
                                                                    maxLength: 30,
                                                                },
                                                            }}
                                                            defaultValue={
                                                                level4CondominiumGroup.level4CondominiumGroupName
                                                            }
                                                            onChange={this.onChangeCondominiumGroupName.bind(
                                                                this,
                                                                String(level4CondominiumGroup.level4CondominiumGroupId),
                                                                level4CondominiumGroup.level4CondominiumGroupVersion,
                                                                String(level2) +
                                                                ',' + String(level3) +
                                                                ',' + String(level4),
                                                            )}
                                                            eventKeys={
                                                                [`${level4CondominiumGroup.level4CondominiumGroupId}_condominiumGroupName`]
                                                            }
                                                            eventEmitter={this.props.eventEmitter}
                                                        />
                                                    </CondominumGroupTextForm>
                                                </LeftRowFlexContainer>
                                            </TableCell>
                                            <TableCell></TableCell>
                                            <TableCell>
                                                {level4CondominiumGroup.level4CondominiumExistFlag === '0' &&
                                                    <DeleteLink
                                                        onClick={() => this.deleteLevel4(
                                                            String(level4CondominiumGroup.level4CondominiumGroupId),
                                                            level2, level3, level4,
                                                        )}>
                                                        削除する
                                                    </DeleteLink>
                                                }
                                            </TableCell>
                                        </TableRow>
                                    ),
                                )
                            }
                        </>))
                    }
                </>))
            }
        </>)
    }

    renderPageMainArea(): ReactElement {
        return (
            <Table>
                <StyledTableCaption>物件グループ情報</StyledTableCaption>
                <TableBody>
                    <TableRow>
                        <TableRowName rowSpan={this.state.condominiumGroupLength}>物件グループ</TableRowName>
                        <TableCell colSpan={3}>
                            <AdminPrimaryButton
                                onClick={this.allCloseButton}
                            >全て閉じる
                            </AdminPrimaryButton>
                            <ButtonMargin/>
                            <AdminPrimaryButton
                                onClick={this.allOpenButton}
                            >全て開く
                            </AdminPrimaryButton>
                        </TableCell>
                    </TableRow>
                    {!judgeAuthorityCheck(HKConstants.CMN.AUTH.EDIT_CONDOMINIUM_GROUP) &&
                        this.rendarViewAuth()
                    }
                    {judgeAuthorityCheck(HKConstants.CMN.AUTH.EDIT_CONDOMINIUM_GROUP) &&
                        this.rendarEditAuth()
                    }
                </TableBody>
            </Table>
        )
    }
}

const ButtonMargin: StyledLabel = styled.label`
  margin-right: 10px;
`

// 入力フォームProps
interface CondominumGroupTextFormProps {
    changeFlg?: Nullable<boolean>;
}

const CondominumGroupTextForm = styled.div<CondominumGroupTextFormProps>`
  display: contents;
  ${props => props.changeFlg === true ? `  & div,text {
    background-color:#ffe0b2;
  }}` : ``};
`

export default createAdminPage(NatAdminCondominiumGroupEditPage)
